import React from 'react';
import styles from './styles.module.css';

export type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';

export interface TitleProps {
  title: string;
  info?: string;
  infoBehavior?: 'wrap' | 'ellipsis';
  markerColor?: 'primary' | 'grey80' | 'grey40';
  iconInfo?: React.ReactNode;
  description?: string;
  size?: 'large' | 'medium' | 'small';
  color?: 'grey90' | 'grey80' | 'grey40' | 'grey10';
  head?: boolean;
  as?: HeadingTag;
  children?: React.ReactNode;
}

export const Title = ({
  title,
  description,
  info,
  infoBehavior = 'wrap',
  iconInfo,
  size = 'medium',
  color = 'grey90',
  markerColor = 'primary',
  head = false,
  as: Tag = 'h1',
  children,
}: TitleProps) => {
  const markerSizeClass = size === 'small' ? styles['infoMarker-small'] : '';

  return (
    <div
      className={`${styles.titleContainer} ${
        head ? styles.titleHeadContainer : ''
      }`}
    >
      <div
        className={` ${styles.titleContent} ${
          head ? styles.titleHeadContent : ''
        }`}
      >
        <span
          className={`${styles.infoMarker} ${
            styles['infoMarker-' + markerColor]
          } ${markerSizeClass}`}
        />
        <div className={styles.textContainer}>
          {info && (
            <div className={styles.infoContainer}>
              {iconInfo}
              <span
                className={`${styles[color]} ${
                  infoBehavior === 'wrap' ? styles.text : styles.textEllipsis
                }`}
              >
                {info}
              </span>
            </div>
          )}

          <Tag
            className={`${styles.titleText} ${styles[size]} ${styles[color]}`}
          >
            {title}
          </Tag>

          {description && (
            <p className={`${styles.text} ${styles[color]}`}>{description}</p>
          )}

          {children}
        </div>
      </div>
    </div>
  );
};
